import { IBaseService, IPaginationDto } from '@/bundles/App/interfaces';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';

export default class VoiceClassService implements IBaseService<any> {
  errorMapper: ErrorMapper;
  transport: HttpTransport;

  constructor(props: IBaseService<any>) {
    this.errorMapper = props.errorMapper;
    this.transport = props.transport;
  }

  getList(params: IPaginationDto) {
    try {
      return this.transport.get('/voice-class/list', params);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  createVoiceClass(formData: FormData) {
    try {
      return this.transport.post('/voice-class/create-with-thumbnail', formData, {'content-type': 'multipart/form-data'});
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  updateVoiceClass(id: number, formData: FormData) {
    try {
      return this.transport.put(`/voice-class/${id}`, formData, {'content-type': 'multipart/form-data'});
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
